import axios from "axios";
var baseUrl = "https://bajajapi.kalyaniktm.com/api/";

async function getAllcontact(setitems, setloading, seterror) {
  await axios
    .get(baseUrl + "location")
    .catch(() => seterror("Not Found"))
    .then((res) => {
      if (res.data.length === 0) seterror("No Data");
      else setitems(res.data);
    });
  setloading(false);
}

export { getAllcontact };
